<template>
  <div>
    <el-dialog title="Fecha de envio" :visible.sync="dialogVisible" width="35%">
      <div class="dialog-date" style="text-align: center">
        <h2>Seleccione una fecha</h2>
        <el-date-picker
          v-model="date"
          type="date"
          format="yyyy-MM-dd"
          placeholder="Selecciones un fecha"
        ></el-date-picker>

        <div style="margin-top: 31px">
          <el-button
            type="primary"
            :loading="buttonLoading"
            @click="SendEmail"
            round
            >Aceptar</el-button
          >
          <el-button type="primary" @click="dialogVisible = false" round
            >Cancelar</el-button
          >
        </div>
      </div>
    </el-dialog>

    <div
      style="
        width: 100%;
        display: flex;
        justify-content: end;
        margin-bottom: 12px;
      "
    >
      <!-- <el-popover placement="top" width="250" v-model="visiblePopover">
        <span>Seguro que quiere una notificacion a todos?</span>
        <div style="text-align: right; margin: 0">
          <el-button size="mini" type="text" @click="visiblePopover = false"
            >Cancelar</el-button
          >
          <el-button type="primary" size="mini" @click="visiblePopover = false"
            >Confirmar</el-button
          >
        </div>
        <el-button slot="reference" type="primary" round
          >Enviar a todos</el-button
        >
      </el-popover> -->

      <el-button type="primary" @click="openDialogSendEmail" round
        >Enviar a todos</el-button
      >
      <el-button type="primary" @click="openDrawerNotification" round
        >Abrir</el-button
      >
    </div>

    <el-drawer
      title="Clientes para notificar"
      :visible.sync="drawer"
      size="50%"
    >
      <div>
        <h2 style="text-align: center">Enviar notificacion</h2>
        <div
          style="
            width: 98%;
            display: flex;
            justify-content: end;
            margin-bottom: 12px;
          "
        >
          <el-date-picker
            v-model="date"
            type="date"
            placeholder="Seleccione un fecha"
            style="margin-right: 20px"
          ></el-date-picker>
          <el-button
            type="primary"
            @click="sendNotificationByCodigos"
            round
            :loading="buttonLoading"
            >Enviar notificacion</el-button
          >
        </div>
        <rabbey-table-3
          :stripe="true"
          :loading="loading"
          :actions="actions"
          :paginateFromApi="true"
          :data="ItemsCheck"
          :columns="columnsDetailsSelect"
          @rtable-push-action="onPushAction"
        />
      </div>
    </el-drawer>

    <!-- <el-button class="dialog-button" type="text" @click="dialogVisible = true">Boton</el-button> -->

    <rabbey-table-3
      :checkBox="true"
      :paginationApi="{
        currentPage: page,
        pageSize: limit,
        total: totalItems
      }"
      :pageSizes="pageSizes"
      :loading="loading"
      :paginateFromApi="true"
      :data="items"
      :columns="columnsDetails"
      @update-current-page="handleCurrentPage"
      @selection-change="handleSelectionChange"
      @update-page-size="handlePageSize"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {
      page: 1,
      limit: 10,
      totalItems: 0,
      pageSizes: [10, 30, 50, 100, 600],
      date: "",
      dialogVisible: false,
      buttonLoading: false,
      drawer: false,
      loading: false,
      Checked: [],
      ItemsCheck: [],
      items: [],
      ClientsCode: [],
      columnsDetails: [
        {
          prop: "ClientCode",
          label: "Codigo",
          width: 100,
          sortable: true
        },
        {
          prop: "Name",
          label: "Nombre",
          width: 620,
          sortable: true
        },
        {
          prop: "Email",
          label: "Email",
          width: 600,
          sortable: true
        },
        {
          prop: "ClientType",
          label: "Tipo",
          width: 130,
          sortable: true
        }
      ],
      columnsDetailsSelect: [
        {
          prop: "ClientCode",
          label: "Codigo",
          width: 120,
          sortable: true
        },
        {
          prop: "Name",
          label: "Nombre",
          width: 750,
          sortable: true
        }
      ],
      actions: [
        {
          icon: "el-icon-delete",
          label: "Eliminar",
          command: "delete-task-delete"
        }
      ]
    };
  },
  created() {
    this.fecthCustomers();
  },
  methods: {
    handleCurrentPage(page) {
      this.page = page;

      this.fecthCustomers();
    },
    handlePageSize(limit) {
      this.limit = limit;

      this.fecthCustomers();
    },
    handleSelectionChange(val) {
      this.Checked = [];
      if (val.length <= 0) {
        this.Checked = [];
      } else {
        val.forEach((value) => {
          const { ClientCode, Name } = value;

          this.Checked.push({
            ClientCode,
            Name
          });
        });
        this.ItemsCheck = this.Checked;
      }
    },
    openDrawerNotification() {
      this.date = "";
      this.ItemsCheck = this.Checked;
      this.drawer = true;
    },
    fecthCustomers() {
      this.items = [];
      this.loading = true;
      this.$http
        .get("/api/customers", {
          timeout: 3 * 60 * 1000,
          params: {
            Page: this.page,
            Limit: this.limit,
            CompanyId: this.currentCompany
          }
        })
        .then((resp) => {
          const { Items, ItemCount, CurrentPage } = resp.data;

          this.items = Items;
          this.totalItems = ItemCount;
          this.page = CurrentPage;
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    async onPushAction(action) {
      this.actionRowData = action;

      let clientCode;
      if (action.row.ClientCode) {
        clientCode = action.row.ClientCode;
      }

      switch (action.command) {
        case "delete-task-delete":
          this.deleteClientNotification(clientCode);
          break;
      }
    },
    openDialogSendEmail() {
      this.date = "";

      this.dialogVisible = true;
    },
    SendEmail() {
      if (this.date === "") {
        this.$message.error(`Por favor selecciones una fecha`);
        return;
      }

      this.buttonLoading = true;
      const dateTime = new Date(this.date);
      const userName = this.currentUser.FullName;

      var year = dateTime.getFullYear();
      var month = String(dateTime.getMonth() + 1).padStart(2, "0"); // Meses van de 0 a 11
      var day = String(dateTime.getDate()).padStart(2, "0");

      this.$http
        .get(`/api/invoices/CreateNotificationInvoice`, {
          params: {
            dateTime: `${year}-${month}-${day}`,
            userName
          }
        })
        .then(() => {
          this.$message({
            type: "success",
            message:
              "El proceso ha terminado. Verificar el log de notificaciones enviada."
          });
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.loading = false;
          this.buttonLoading = false;
        });
    },
    sendNotificationByCodigos() {
      if (this.date === "") {
        this.$message.error(`Por favor selecciones una fecha`);
        return;
      }

      const dateTime = new Date(this.date);
      const userName = this.currentUser.FullName;

      var year = dateTime.getFullYear();
      var month = String(dateTime.getMonth() + 1).padStart(2, "0"); // Meses van de 0 a 11
      var day = String(dateTime.getDate()).padStart(2, "0");

      this.ClientsCode = [];

      this.ItemsCheck.forEach((value) => {
        const { ClientCode } = value;
        this.ClientsCode.push(ClientCode);
      });

      const clientCode = this.ClientsCode;

      this.buttonLoading = true;
      this.$http
        .post(`/api/invoices/CreateNotificationInvoiceByList`, clientCode, {
          params: {
            dateTime: `${year}-${month}-${day}`,
            userName
          }
        })
        .then(() => {
          this.$message({
            type: "success",
            message:
              "El proceso ha terminado. Verificar el log de notificaciones enviada."
          });
        })
        .catch((error) => {
          console.error(error);
          console.log("llegue");
        })
        .finally(() => {
          this.loading = false;
          this.buttonLoading = false;
        });
    },
    deleteClientNotification(clientCode) {
      this.loading = true;

      this.ItemsCheck = this.ItemsCheck.filter(
        (element) => element.ClientCode != clientCode
      );

      this.loading = false;
    }
  }
};
</script>
